import { VirtualItem } from "@tanstack/react-virtual"
import { useEffect } from "react"
import { PhotoId } from "@/store/undoable-state"
import { useSetAtom } from "jotai"
import { visibleThumbnailsAtom } from "@/store/previews/previews-state"

export const useVisibleThumbnails = (args: {
	rows?: VirtualItem[]
	cols?: VirtualItem[]
	photoIds: string[]
	additionalPhotoIds?: string[]
	isShown: boolean
}) => {
	const { rows, cols, photoIds, additionalPhotoIds, isShown } = args

	const firstRow = rows?.[0]
	const lastRow = rows?.[rows.length - 1]
	const firstCol = cols?.[0]
	const lastCol = cols?.[cols.length - 1]
	const rowRange = firstRow && lastRow ? `${firstRow.index}:${lastRow.index}` : ""
	const colRange = firstCol && lastCol ? `${firstCol.index}:${lastCol.index}` : ""

	const setVisibleThumbnails = useSetAtom(visibleThumbnailsAtom)

	useEffect(() => {
		if (!isShown) {
			return
		}

		const visibleThumbnails = new Set<PhotoId>(additionalPhotoIds)
		const addVisible = (index: number) => {
			const photoId = photoIds[index]

			if (!photoId) return

			visibleThumbnails.add(photoId)
		}

		if (rows && cols) {
			// Grid view
			for (const row of rows) {
				for (const col of cols) {
					addVisible(row.index * cols.length + col.index)
				}
			}
		} else {
			const cells: VirtualItem[] = rows || cols || []

			for (const cell of cells) {
				addVisible(cell.index)
			}
		}

		setVisibleThumbnails(visibleThumbnails)
	}, [rowRange, colRange, photoIds, additionalPhotoIds, isShown])
}
